import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const GET_STOCK_ORDER_RECONCILIATION = 'GET_STOCK_ORDER_RECONCILIATION';

const apiCall = createApiCall(
  GET_STOCK_ORDER_RECONCILIATION,
  (params: {
    order_source?: string;
    account_source?: string;
    from_month?: string;
    to_month?: string;
  }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/stock-orders/reconciliation`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
